/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import T from '@prisjakt/ui-translate';
import { AppContext } from '@prisjakt/ui-app-context';
import CtxLink from '../render-context/ctx-link';

import acceptCookies from './actions';
import * as S from './styles';

/**
  Cookie banner reads state from localstorage and/or cookie.
  Because of this we cannot render the cookie banner server side
  as usual since users with previous accepts will get a "flash-
  of-already-accepted-cookie-banner".

  The componentDidMount makes sure cookie banner only renders client side
* */
class CookieBanner extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  componentDidMount() {
    this.setState({ show: true });
  }

  render() {
    const { t, renderMode, market } = this.context;

    if (!this.state.show) {
      return null;
    }

    if (renderMode === 'native') {
      return null;
    }

    const privacySettings =
      market.privacySettings[renderMode] || market.privacySettings.responsive;

    if (this.props.version === privacySettings.cookieVersion) {
      return null;
    }

    return (
      <S.Banner id="cookie-banner" data-test="CookieBanner" show>
        <S.BannerContent>
          <S.BannerText>
            <T
              domain="common"
              cookiePolicyLink={
                <CtxLink to={privacySettings.cookieUrl}>
                  {t('common', 'cookie-banner.cookie-policy')}
                </CtxLink>
              }
              privacyPolicyLink={
                <CtxLink to={privacySettings.privacyUrl}>
                  {t('common', 'cookie-banner.privacy-policy')}
                </CtxLink>
              }
            >
              cookie-banner.description
            </T>
            <S.PrivacyLinks>
              <CtxLink to={privacySettings.privacySettingsUrl}>
                {t('common', 'cookie-banner.privacy-policy-settings')}
              </CtxLink>
            </S.PrivacyLinks>
          </S.BannerText>
          <S.AcceptButton
            mobile
            color="primary"
            variant="outlined"
            onClick={() =>
              this.props.acceptCookies(privacySettings.cookieVersion)
            }
          >
            <T domain="common">button.ok</T>
          </S.AcceptButton>
          <S.AcceptButton
            desktop
            color="primary"
            variant="outlined"
            onClick={() =>
              this.props.acceptCookies(privacySettings.cookieVersion)
            }
          >
            <T domain="common">cookie-banner.accept-button</T>
          </S.AcceptButton>
        </S.BannerContent>
      </S.Banner>
    );
  }
}

const { func, string, object } = PropTypes;

CookieBanner.propTypes = {
  acceptCookies: func.isRequired,
  version: string,
  privacySettings: object, // eslint-disable-line react/forbid-prop-types
};

CookieBanner.defaultProps = {
  version: undefined,
  privacySettings: undefined,
};

CookieBanner.contextType = AppContext;

export default connect(
  state => state.globals.cookieBanner,
  { acceptCookies }
)(CookieBanner);
